export default "__VITE_ASSET__d30757d0__"